import axios from "axios";

// const URL = 'https://stagingapi.birmind.cloud/api/v1/'
const URL ='https://api.birmind.cloud/api/v1/'

const api = axios.create({
    baseURL: URL,
})

api.interceptors.response.use((response) => {

    return response
 },
  function (error) {
    const originalRequest = error.config;
    console.log(error.config)
    if (error.response.status === 401 && !originalRequest._retry) {
        if (error.config.url === "/get-token/refresh/") {
            localStorage.removeItem('@manager-app/refresh-token')
            return Promise.reject(error)
        }
        const refreshToken = localStorage.getItem('@manager-app/refresh-token')
        if (refreshToken != null && refreshToken.length !== 0) {
            originalRequest._retry = true;
            console.log("Refreshing Token...")
            return api.post(
                "/get-token/refresh/", {refresh: refreshToken}
                )
                .then(res => {
                    if (res.status === 200) {
                        api.defaults.headers['Authorization'] = 'Bearer ' + res.data.access;
                        originalRequest.headers["Authorization"] = api.defaults.headers["Authorization"]
                        return axios(originalRequest);
                    }
                }).catch((err)=>{
                    // logout
                    localStorage.removeItem('@manager-app/refresh-token')
                    console.log('error: '+err)
                })
        }
    }
    return Promise.reject(error)
});

export default api
